import type { PostgresAppRouter } from '@trpc-endpoints/trpc-pg/router'
import { createTRPCProxyClient, httpBatchLink } from '@trpc/client'
import { trpcFetcher } from 'reusable/fetching/trpc-fetcher'
import variables from 'variables/variables'
import superjson from 'superjson'
import { AuthSession, fetchAuthSession } from 'aws-amplify/auth'
import { errorTransformerLink } from '../trpc/trpc-client'

/**
 * Postgres-backed API client
 * Uses /api/ routes (separate from /trpc/ DynamoDB routes)
 */
const createPostgresClient = (silent = false) => {
   return createTRPCProxyClient<PostgresAppRouter>({
      transformer: superjson,
      links: [
         errorTransformerLink,
         httpBatchLink({
            url: `${variables.apiUrl}/api`,
            maxURLLength: 2048,
            async fetch(input: RequestInfo | URL, options?: RequestInit): Promise<Response> {
               let token: string | null = null
               const session: AuthSession = await fetchAuthSession()

               // check to see if we have a token issued using amplify
               if (!session.tokens?.accessToken) {
                  // if not, then check our gap issued tokens
                  token = localStorage.getItem(variables.gapAccessTokenLocalStorageKey)
                  if (!token) {
                     throw new Error('User has no access token.')
                  }
               } else {
                  token = session.tokens.accessToken.toString()
               }

               return trpcFetcher({
                  silent,
                  fetchParams: [input, options],
                  cors: true,
                  auth: { type: 'jwt', token },
               })
            },
         }),
      ],
   })
}

export const postgresApiClient = createPostgresClient()
export const postgresApiClientSilent = createPostgresClient(true)
